
import { ServiceLandingPage } from "@/components/service/ServiceLandingPage";

const WindowCleaningPage = () => {
  const features = [
    {
      title: "Residential Window Cleaning",
      description: "Professional cleaning for homes of all sizes"
    },
    {
      title: "Commercial Services",
      description: "Window cleaning for office buildings, storefronts, and commercial properties"
    },
    {
      title: "High-Rise Specialists",
      description: "Safe and effective cleaning for multi-story buildings"
    },
    {
      title: "Screen Cleaning",
      description: "Thorough cleaning of window screens to remove dirt and debris"
    },
    {
      title: "Gutter Cleaning",
      description: "Complete gutter cleaning and maintenance services"
    }
  ];

  const processSteps = [
    {
      title: "Free Estimate",
      description: "Accurate quote based on your specific window cleaning needs"
    },
    {
      title: "Professional Service",
      description: "Experienced technicians using safe and effective methods"
    },
    {
      title: "Thorough Cleaning",
      description: "Detail-oriented approach for streak-free, spotless results"
    },
    {
      title: "Final Inspection",
      description: "Quality check to ensure your complete satisfaction"
    }
  ];

  const benefits = [
    {
      title: "Enhanced Appearance",
      description: "Crystal-clear windows that improve your property's look and feel"
    },
    {
      title: "Extended Window Life",
      description: "Regular cleaning helps prevent glass degradation and damage"
    },
    {
      title: "Improved Natural Light",
      description: "Clean windows allow more sunlight into your home"
    },
    {
      title: "Safety",
      description: "Professional equipment and techniques eliminate the risks of DIY cleaning"
    },
    {
      title: "Time Savings",
      description: "Reclaim your time while professionals handle the hard work"
    }
  ];

  return (
    <ServiceLandingPage
      title="Window Cleaning Services in Oklahoma City"
      metaDescription="Professional window cleaning services in Oklahoma City for residential and commercial properties."
      introText="Connect with Oklahoma City's best window cleaning professionals for spotless, streak-free windows."
      features={features}
      processSteps={processSteps}
      benefits={benefits}
      ctaText="Ready for spotless windows?"
      ctaButtonText="Get Connected"
      contactText="Fill out the form below to connect with top-rated window cleaning professionals in OKC."
    />
  );
};

export default WindowCleaningPage;
